<app-reject-call-dialog
  [step]="step()"
  [selectedReason]="selectedReason()"
  [reasonOptions]="reasonOptions()"
  [busy]="busy()"
  [callerLabel]="callerLabel()"
  (dismiss)="onDismiss()"
  (proceedToReasonSelection)="onProceedToReasonSelection()"
  (selectReason)="onSelectReason($event)"
  (confirmReject)="onConfirmReject()" />
